import { render, staticRenderFns } from "./DriverPlatfromInfo.vue?vue&type=template&id=3f7fa3dc&scoped=true"
import script from "./DriverPlatfromInfo.vue?vue&type=script&lang=js"
export * from "./DriverPlatfromInfo.vue?vue&type=script&lang=js"
import style0 from "./DriverPlatfromInfo.vue?vue&type=style&index=0&id=3f7fa3dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7fa3dc",
  null
  
)

export default component.exports